import { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Compliance from "@/pages/Compliance";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cookies from "@/pages/Cookies";
import Leadership from "@/pages/Leadership";
import GlobalNetwork from "@/pages/GlobalNetwork";
import Industries from "@/pages/Industries";
import Admin from "@/pages/Admin";
import CookieConsent from "@/components/site/CookieConsent";

function ScrollToTop() {
  const { pathname, state } = useLocation();
  useEffect(() => {
    if (state && state.scrollTo) return; // handled by Landing
    window.scrollTo(0, 0);
  }, [pathname, state]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/global-network" element={<GlobalNetwork />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookie-policy" element={<Cookies />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <CookieConsent />
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1A1D20",
              color: "#FDFBF7",
              border: "1px solid #C5A059",
              borderRadius: "2px",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </div>
    </HelmetProvider>
  );
}

export default App;
